<template>
  <div class="content-wrap">
    <h2>Verander je wachtwoord</h2>

    <ChangePasswordForm/>
  </div>
</template>

<script>
import ChangePasswordForm from "@/components/blocks/ChangePasswordForm.vue";

export default {
  name: "ChangePassword",
  components: {
    ChangePasswordForm,
  },
};
</script>
